// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap/dist/css/bootstrap.css'
import Vue from 'vue'
import App from './App'
import router from './router'
import BootstrapVue from 'bootstrap-vue'
import {vueAccordion} from 'vue-accordion'
import VueAgile from 'vue-agile'

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.component('vue-accordion', vueAccordion)
Vue.use(VueAgile)

/* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   router,
//   template: '<App/>',
//   components: { App }
// })

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
